export default __webpack_public_path__ + "static/media/Montserrat-Black-900.46e8b3d6.ttf";